import { isChatApiError } from '../api/errors.js';
import { t } from '../i18n/index.js';

/** Texto de um erro da API para a pessoa (pelo código do Discord). */
export function mensagemDeErro(erro: unknown): string {
  if (isChatApiError(erro)) {
    if (erro.isUnavailable) return t('erros.semConexao');
    if (erro.code !== null) {
      const chave = `erros.${erro.code}`;
      const texto = t(chave);
      if (texto !== chave) return texto;
    }
    return erro.message || t('erros.generico');
  }
  return t('erros.generico');
}
